
import "@/assets/sass/template.scss";
import { defineComponent, onMounted, reactive, ref } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import store from "@/store";
import moment from "moment";
import VTable from "./Table.vue";
import VSimpleTable from "./SimpleTable.vue";
import ApiService from "@/core/services/ApiService";
import PaginationUtill from "../util/PaginationUtill";
import { file } from "@/assets/js/alga";
import { t } from "element-plus/lib/locale";

export default defineComponent({
  name: "ScannedInvoices",
  data() {
    return {
      header: this.getheader(),
      foldercontent: [],
      foldercontentbackup: [],
      isfolderContent: false,
      searchType: "0",
      fileIds: ["None"],
      fromLOC: null,
      toLOC: null,
      fromDate: null,
      toDate: null,
      searchUtilty: null,
      rptNo: null,
      searchText: "",
      email: null,
      DisplayLoc_Id: true,
      selectedCols: [],
      typeSelectionModal: false,
      isLOCIdHidden: false,
      isUtilityHidden: false,
      isRptNoHidden: false,
      isCMRHidden: false,
      isCSRHidden: false,
      isSupplierHidden: false,
      isAddressHidden: false,
      isMSNHidden: false,
      isSACHidden: false,
      isInvoiceHidden: false,
      isTPHidden: false,
      isBPHidden: false,
      isNetHidden: false,
      isVatHidden: false,
      isTotalHidden: false,
      showLOCId: true,
      showUtility: true,
      showRptNo: true,
      showCMR: true,
      showCSR: true,
      showSupplier: true,
      showAddress: true,
      showMSN: true,
      showSAC: true,
      showInvoice: true,
      showTP: true,
      showBP: true,
      showNet: true,
      showVat: true,
      showTotal: true,
      loading: false,
    };
  },
  computed: {
    enableSearch() {
      if (this.searchType) {
        if (this.searchType == "1") {
          return true;
        }
      }
      return true;
    },
  },
  mounted() {
    setCurrentPageBreadcrumbs("Scanned Invoices", ["NA"]);
    //this.setUserFolders();
    this.getFolderContent(null);
  },
  components: {
    VTable,
    // VModal,
    // VSimpleTable,
  },

  methods: {
    addtoDownload(item) {
      const index = this.fileIds.indexOf(item.row.Box_FileId);
      if (index > 0) {
        this.fileIds.splice(index, 1);
      } else {
        this.fileIds.push(item.row.Box_FileId.toString());
      }
    },
    showHideCols(x) {
      switch (x.toString()) {
        case "1":
          this.isLOCIdHidden = !this.isLOCIdHidden;
          break;
        case "2":
          this.isUtilityHidden = !this.isUtilityHidden;
          break;
        case "3":
          this.isRptNoHidden = !this.isRptNoHidden;
          break;
        case "4":
          this.isCMRHidden = !this.isCMRHidden;
          break;
        case "5":
          this.isCSRHidden = !this.isCSRHidden;
          break;
        case "6":
          this.isSupplierHidden = !this.isSupplierHidden;
          break;
        case "7":
          this.isAddressHidden = !this.isAddressHidden;
          break;
        case "8":
          this.isMSNHidden = !this.isMSNHidden;
          break;
        case "9":
          this.isSACHidden = !this.isSACHidden;
          break;
        case "10":
          this.isInvoiceHidden = !this.isInvoiceHidden;
          break;
        case "11":
          this.isTPHidden = !this.isTPHidden;
          break;
        case "12":
          this.isBPHidden = !this.isBPHidden;
          break;
        case "13":
          this.isNetHidden = !this.isNetHidden;
          break;
        case "14":
          this.isVatHidden = !this.isVatHidden;
          break;
        case "15":
          this.isTotalHidden = !this.isTotalHidden;
          break;
      }
      this.header = this.getfileheader();
    },
    showItem(item) {
      this.getFolderContent(item.Id);
    },
    getfileheader() {
      return [
        {
          key: "Action",
          value: "",
          custom: true,
          isSortable: false,
          onClick: (item) => this.addtoDownload(item),
        },
        {
          key: "Loc_Id",
          value: "Loc Id",
          isSortable: true,
          ishidden: this.isLOCIdHidden,
        },
        {
          key: "Utility_Type",
          value: "Utility Type",
          isSortable: true,
          ishidden: this.isUtilityHidden,
        },
        {
          key: "ReportNo",
          value: "Report No",
          width: "20%",
          isSortable: true,
          ishidden: this.isRptNoHidden,
        },
        {
          key: "Client_Meter_Ref",
          value: "Client Meter Ref",
          width: "10%",
          isSortable: true,
          ishidden: this.isCMRHidden,
        },
        {
          key: "Client_Site_Ref",
          value: "Client Site Ref",
          width: "10%",
          isSortable: true,
          ishidden: this.isCSRHidden,
        },
        {
          key: "Supplier",
          value: "Supplier",
          width: "20%",
          isSortable: true,
          ishidden: this.isSupplierHidden,
        },
        {
          key: "Address",
          value: "Address",
          width: "20%",
          isSortable: true,
          ishidden: this.isAddressHidden,
        },
        {
          key: "Meter_Serial_No",
          value: "Meter Serial No",
          width: "20%",
          isSortable: true,
          ishidden: this.isMSNHidden,
        },
        {
          key: "Supplier_Acc_No",
          value: "Supplier Acc No",
          width: "20%",
          isSortable: true,
          ishidden: this.isSACHidden,
        },
        {
          key: "Invoice_No",
          value: "Invoice No",
          width: "20%",
          //onClick: (item) => this.downloadItem(item),
          isSortable: true,
          ishidden: this.isInvoiceHidden,
        },
        {
          key: "Tax_Point",
          value: "Tax Point",
          width: "20%",
          isSortable: true,
          ishidden: this.isTPHidden,
          type: "Date",
        },
        {
          key: "Bill_Period",
          value: "Bill Period",
          width: "24%",
          isSortable: true,
          ishidden: this.isBPHidden,
        },
        {
          key: "Net",
          value: "Net",
          width: "20%",
          isSortable: true,
          ishidden: this.isNetHidden,
        },
        {
          key: "VAT",
          value: "VAT",
          width: "20%",
          isSortable: true,
          ishidden: this.isVatHidden,
        },
        {
          key: "Total",
          value: "Total",
          width: "20%",
          isSortable: true,
          ishidden: this.isTotalHidden,
        },

        /*    { key: "OpportunityStageName", value: "Stage", width: "12%" },
        {
          key: "OpportunityOwnerName",
          value: "Opportunity Owner",
          width: "20%",
        }, */
      ];
    },
    getheader() {
      return [
        {
          key: "Name",
          value: "Name",
          onClick: (item) => this.showItem(item),
        },
        { key: "Size", value: "Size", width: "24%" },
        { key: "Modified", value: "Modified", width: "20%", type: "DateTime" },
      ];
    },
    downloadInvoice(Id) {
      const FileIdModel: any = {
        fileIds: Id,
      };
      let url =
        ApiService.vueInstance.axios.defaults.baseURL +
        "api/Invoice/Download/" +
        Id;
      window.open(url);
    },
    downloadInvoices() {
      const index = this.fileIds.indexOf("None");
      if (index == 0 && this.fileIds.length == 1) {
        return;
      }

      const FileIdModel: any = {
        fileIds: this.fileIds,
      };

      let url =
        ApiService.vueInstance.axios.defaults.baseURL +
        "api/Invoice/Download/" +
        this.fileIds;
      window.open(url);
    },

    ReloadScreen() {
      window.location.reload();
    },

    getFolderContent(Id) {
      if (Id == null) {
        Id = 1;
      }
      const FolderInfo: any = {
        FolderId: Id,
        email: store.getters.emailid,
      };
      this.loading = true;
      return ApiService.post("api/Invoice/folder", FolderInfo)
        .then((resp) => {
          if (resp.data.CompanyInfoVM == null) {
            this.isfolderContent = false;
            this.foldercontent = resp.data;
            this.header = this.getheader();
          } else {
            this.isfolderContent = true;
            this.foldercontentbackup = this.foldercontent =
              resp.data.BillMetaDataVM;
            this.header = this.getfileheader();
          }
        })
        .catch((error) => {
          //this.loading = false;
          console.log(error);
        });
    },
    search() {
      const searchCriteria: any = {
        SearchText: this.searchText,
        SearchType: this.searchType,
        From: this.fromLOC,
        To: this.toLOC,
        DateFrom: moment(this.fromDate).format("YYYY-MM-DD 00:00:00"),
        DateTo: moment(this.toDate).format("YYYY-MM-DD 00:00:00"),
        UtilityType: this.searchUtilty,
        RptNo: this.rptNo,
      };

      const SearchVMData: any = {
        BillMetaDataVM: this.foldercontentbackup,
        searchCriteria: searchCriteria,
      };
      return ApiService.post("api/Invoice/sortfolder", SearchVMData)
        .then((resp) => {
          this.foldercontent = [];
          this.foldercontent = resp.data;
          this.header = this.getfileheader();
        })
        .catch((error) => {
          //this.loading = false;
          console.log(error);
        });
    },
    clearSearch() {
      this.searchText = "";
      this.searchType = "0";
      this.foldercontent = this.foldercontentbackup;
    },
  },
});
